import { ChangeDetectorRef, Directive, type OnInit, TemplateRef, ViewContainerRef, input, DestroyRef, inject } from '@angular/core';
import { map } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { UserRole } from '@protctc/common/core/models/user/user-role';
import { filterNull } from '@protctc/common/core/rxjs/filter-null';
import { UserService } from '@protctc/common/core/services/user.service';

import { ConditionalRenderingDirective } from './conditional-rendering.directive';

/**
 * Directive that render content only if
 * user's current role is the same as the one passed.
 */
@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: '[userHasRole]',
})
export class HasUserRoleDirective extends ConditionalRenderingDirective implements OnInit {
	private readonly userService = inject(UserService);

	private readonly destroyRef = inject(DestroyRef);

	/** The role that the current user must have. */
	public readonly userHasRole = input<UserRole>(UserRole.BusinessOwner);

	public constructor() {
		const vcr = inject(ViewContainerRef);
		const cdr = inject(ChangeDetectorRef);
		const templateRef = inject<TemplateRef<unknown>>(TemplateRef);

		super(vcr, cdr, templateRef);
	}

	/** @inheritdoc */
	public ngOnInit(): void {
		this.userService.currentUser$.pipe(
			filterNull(),
			map(user => user.role === this.userHasRole()),
			takeUntilDestroyed(this.destroyRef),
		)
			.subscribe(hasUserPermission => {
				if (hasUserPermission) {
					this.renderContent();
				} else {
					this.clearContent();
				}
			});
	}
}
